module.exports = __webpack_public_path__ + "static/media/men-preview.80bf6fdd.jpg";